import feathersClient, {BaseModel, makeServicePlugin} from '../../feathers-client'
import {DateTime} from "luxon";

class Event extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Event';

    // Define default properties here
    static instanceDefaults() {
        return {
            name: '',
            start_date: null,
            end_date: null,
            event_type: 0,
            companyId: null,
        }
    }

    static setupInstance(data, {models}) {
        if (data.start_date) {
            data.start_date = DateTime.fromISO(data.start_date).toFormat('yyyy-MM-dd');
        }
        if (data.end_date) {
            data.end_date = DateTime.fromISO(data.end_date).toFormat('yyyy-MM-dd');
        }

        if (data.events_layout) {
            data.events_layout = new models.api.EventLayout(data.events_layout);
        } else {
            data.events_layout = new models.api.EventLayout({eventId: data.id});
        }

        if (data.events_color) {
            data.events_color = new models.api.EventColor(data.events_color);
        } else {
            data.events_color = new models.api.EventColor({eventId: data.id});
        }

        if (data.f_home) {
            data.f_home = new models.api.EventHome(data.f_home);
        } else {
            data.f_home = new models.api.EventHome({eventId: data.id});
        }

        if (data.f_about) {
            data.f_about = new models.api.EventAbout(data.f_about);
        } else {
            data.f_about = new models.api.EventAbout({eventId: data.id});
        }

        if (data.f_agenda) {
            data.f_agenda = new models.api.EventAgenda(data.f_agenda);
        } else {
            data.f_agenda = new models.api.EventAgenda({eventId: data.id});
        }

        if (data.f_speaker) {
            data.f_speaker = new models.api.EventSpeaker(data.f_speaker);
        } else {
            data.f_speaker = new models.api.EventSpeaker({eventId: data.id});
        }

        if (data.apps_events) {
            data.apps_events = new models.api.AppEvent(data.apps_events);
        } else {
            data.apps_events = [];
        }
        if (data.events_profile){
            data.events_profile = new models.api.EventProfile(data.events_profile);
        }else{
            data.events_profile = new models.api.EventProfile({eventId: data.id});
        }
        
        return data
    }
}

const servicePath = 'events';
const servicePlugin = makeServicePlugin({
    Model: Event,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin